module.exports = __webpack_public_path__ + "img/1.07a15791.png";